import { type FC } from 'react';
import { Route } from 'react-router';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { HydrogenInteractingUsersOverview } from 'src/pages/h2/fcfs/interacting-users/overview';

export const HydrogenInteractingUsers: FC = () => {
  return (
    <RootRoutes>
      <Route
        path="/h2/fcfs/interacting-users"
        element={<HydrogenInteractingUsersOverview />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
